<template>
  <!-- 上下两个图片 -->
  <div class="columnTwo">
    <div class="top">
      <a :href="top.link_url">
        <img :src="top.photo1" alt />
      </a>
      <div class="topimgtitle" :title="top.title">{{top.title}}</div>
    </div>
    <div class="middle"></div>
    <div class="bottom">
      <a :href="bottom.link_url">
        <img :src="bottom.photo1" alt />
      </a>
      <div class="bottomimgtitle" :title="bottom.title">{{bottom.title}}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: ["top", "bottom"],
  methods: {
    goGroup(item) {
      this.$router.push({
        path: "/searchSingle",
        query: {
          isEnglish: false,
          type: 0,
          text: "",
          group_id: item.group_id
        }
      });
    }
  }
};
</script>

<style lang="less">
.columnTwo {
  width: 100%;
  height: 100%;
  .middle {
    height: 10px;
    width: 100%;
  }
  .top {
    height: calc(50% - 5px);
    width: 100%;
    box-sizing: border-box;
    position: relative;
    .topimgtitle {
      position: absolute;
      left: 0px;
      bottom: 0px;
      width: 100%;
      height: 42px;
      background-color: rgba(0, 0, 0, 0.5);
      color: white;
      line-height: 42px;
      box-sizing: border-box;
      padding-left: 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .bottom {
    height: calc(50% - 5px);
    width: 100%;
    box-sizing: border-box;
    position: relative;
    .bottomimgtitle {
      position: absolute;
      left: 0px;
      bottom: 0px;
      width: 100%;
      height: 42px;
      background-color: rgba(0, 0, 0, 0.5);
      color: white;
      line-height: 42px;
      box-sizing: border-box;
      padding-left: 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/columnTwo.vue